import { FC } from 'react';
import { Image, Skeleton } from "antd";

import useInfoScreen from '../../useInfoScreen';
import { EditableContent } from "../EditableContent";
import cross from "../../images/cross-patch.png";
import { ScreenButtons } from "../ScreenButtons";
import { ScreenButton } from "../ScreenButton";
import { ScreenLayout } from "../ScreenLayout";
import styles from './index.module.scss'

export const NoOrdersScreen: FC<{ screenId: number }> = ({ screenId }) => {
  const { data, onEdit, loading } = useInfoScreen(screenId);
  if (loading) {
    return <Skeleton active={true} />;
  }
  return(
    <ScreenLayout>
      <Image
        width={201}
        height={201}
        alt="profile"
        preview={false}
        src={cross}
      />
      <div className={styles.body}>
        <EditableContent type="header" maxLength={90} onSave={onEdit}>
          {data?.header}
        </EditableContent>
        <EditableContent type="body" maxLength={130} onSave={onEdit}>
          {data?.body}
        </EditableContent>
      </div>
      <ScreenButtons>
        <ScreenButton>
          Перейти к услугам
        </ScreenButton>
      </ScreenButtons>
    </ScreenLayout>
  )
}